import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import RequireModule from '@/core/modules/RequireModule';
import { Modules } from '@/core/modules/moduleKeys';

// Pages load when first opened (NFR-04).
const SigningPage = lazy(() => import('./pages/SigningPage'));
const SigningRequestPage = lazy(() => import('./pages/SigningRequestPage'));
const SignTaskPage = lazy(() => import('./pages/SignTaskPage'));
const PublicSignPage = lazy(() => import('./pages/PublicSignPage'));

/**
 * Electronic signatures (docs §219). No permission guards the area: anyone may have something to sign, and the server
 * decides what each person may see; the module must be on.
 */
export const signingRoutes: RouteObject[] = [
  { path: 'signing/requests/:id', element: <RequireModule module={Modules.Signing}><SigningRequestPage /></RequireModule> },
  { path: 'signing/sign/:recipientId', element: <RequireModule module={Modules.Signing}><SignTaskPage /></RequireModule> },
  { path: 'signing/:view?', element: <RequireModule module={Modules.Signing}><SigningPage /></RequireModule> },
];

/** An outside signer's invitation link: no account, outside the signed-in layout. */
export const signingPublicRoutes: RouteObject[] = [
  { path: '/sign/:orgSlug/:token', element: <PublicSignPage /> },
];
